import NavigationTabs from "./NavigationTabs";
import CheckIsMobile from "./mobile";

export default function Header()
{
    let IsMobile = CheckIsMobile();

    return (
        <div style={{ flexDirection: "column", positon: "fixed", top: "20px", left:"50px", display: "flex", justifyContent: "center", alignItems: "center", padding:20, zIndex: 1000 }}>
            <img
            src="https://amvco.com.au/wp-content/uploads/2021/05/AMVLogoWhiteBorder.png"
            alt="AMV Logo"
            height="100"
            width="200"
            />
            
            <br />
            <div style={{ display:"flex", justifyContent: "center", alignItems: "center"}}>
                <h1 style={{color:"cyan", fontSize: IsMobile ? 30 : 40, textAlign: "center"}}> Our VISION is Your SOLUTION</h1>
            </div>

            <br />
            <NavigationTabs/>
        </div>
    );
}